webpackJsonp([274673045319241],{

/***/ 1992:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---features-handoff-assets-a0e39f21c11f6a62c5ab.js